/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputNumberComponent = {
    template: require('./gmao-input-number.html'),
    bindings: {
        model: '=',
        modelOptions: '<',
        validationError: '<',
        disabled: '<',
        readonly: '<',
        required: '<',
        min: '<',
        max: '<',
        placeholderKey: '<',
        hintKey: '<',
        labelNoFloat: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputNumber.js